// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payroll-breakdown {
  margin-top: var(--ds-space-2);
}

.payroll-line {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--ds-space-4);
  padding: var(--ds-space-1) 0;
}

.payroll-line + .payroll-line {
  border-top: 1px solid var(--ds-border-soft);
}

.payroll-line__label {
  min-width: 0;
  color: var(--ds-text);
  overflow-wrap: anywhere;
}

.payroll-line__label--muted {
  color: var(--ds-text-muted);
  padding-inline-start: var(--ds-space-3);
}

.payroll-line__value {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: end;
}

.payroll-line--strong {
  font-weight: 600;
  border-top: 1px solid var(--ds-border);
  margin-top: var(--ds-space-1);
  padding-top: var(--ds-space-2);
}

.payroll-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.payroll-inline .ant-tag {
  margin-inline-end: 0;
  white-space: normal;
}

/* Payroll filings (PayrollReports.jsx) */
.payroll-reports .payroll-reports__field {
  margin-bottom: var(--ds-space-3);
}

.payroll-reports .ant-card-head-title {
  white-space: normal;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Payroll/Payroll.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".payroll-breakdown {\n  margin-top: var(--ds-space-2);\n}\n\n.payroll-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: var(--ds-space-4);\n  padding: var(--ds-space-1) 0;\n}\n\n.payroll-line + .payroll-line {\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.payroll-line__label {\n  min-width: 0;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n}\n\n.payroll-line__label--muted {\n  color: var(--ds-text-muted);\n  padding-inline-start: var(--ds-space-3);\n}\n\n.payroll-line__value {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  text-align: end;\n}\n\n.payroll-line--strong {\n  font-weight: 600;\n  border-top: 1px solid var(--ds-border);\n  margin-top: var(--ds-space-1);\n  padding-top: var(--ds-space-2);\n}\n\n.payroll-inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.payroll-inline .ant-tag {\n  margin-inline-end: 0;\n  white-space: normal;\n}\n\n/* Payroll filings (PayrollReports.jsx) */\n.payroll-reports .payroll-reports__field {\n  margin-bottom: var(--ds-space-3);\n}\n\n.payroll-reports .ant-card-head-title {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
